import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=a6aab070&scoped=true&"
import script from "./UsersPage.vue?vue&type=script&lang=js&"
export * from "./UsersPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=a6aab070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aab070",
  null
  
)

export default component.exports